module.exports = __webpack_public_path__ + "img/product4.719de4c6.png";